import { GradientBackground } from 'src/common/components/gradient-background';
import { StyledButton, StyledContainer, StyledCtaTitle, StyledImageWrapper } from 'src/features/home/components/cta/cta.styles';
import { ReactComponent as BackgroundImage } from 'src/images/svgs/pricing-page-cta-background.svg';
import type { CtaProps } from './cta.types';
export const Cta: React.FC<CtaProps> = ({
  onClick
}) => <GradientBackground data-sentry-element="GradientBackground" data-sentry-component="Cta" data-sentry-source-file="cta.tsx">
    <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="cta.tsx">
      <StyledImageWrapper data-sentry-element="StyledImageWrapper" data-sentry-source-file="cta.tsx">
        <BackgroundImage data-testid="cta-background-svg" data-sentry-element="BackgroundImage" data-sentry-source-file="cta.tsx" />
      </StyledImageWrapper>
      <StyledCtaTitle data-sentry-element="StyledCtaTitle" data-sentry-source-file="cta.tsx">Ready to start learning cyber security?</StyledCtaTitle>
      <StyledButton onClick={onClick} data-sentry-element="StyledButton" data-sentry-source-file="cta.tsx">Join for FREE</StyledButton>
    </StyledContainer>
  </GradientBackground>;